import Keycloak from 'keycloak-js';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keyCloakInstance = new Keycloak('/keycloak.json');
export default keyCloakInstance;